import { handleActions } from 'redux-actions'

import { actions } from '../actions/participants'

const defaultState = {
    active_participants: undefined,
    archived_participants: undefined,
    participant_details: {},
    participant_sessions: [],
    participant_session_details: {},
    available_exercises: [],
    participant: {},
    location: {
        section: 'performance',
        subsection: undefined,
        module: undefined,
        item: undefined
    }
}

const resetParticipants = (_state, _action) => {
    return defaultState
}

const changeLocation = (state, action) => {
    return { ...state, location: { ...state.location, ...action.payload } }
}

const setParticipant = (state, action) => {
    return {
        ...state,
        participant: action.payload,
        location: state.participant.id !== action.payload.id ? defaultState.location : state.location
    }
}

const setActiveParticipants = (state, action) => {
    return { ...state, active_participants: action.payload }
}

const setArchivedParticipants = (state, action) => {
    return { ...state, archived_participants: action.payload }
}

const setParticipantDetails = (state, action) => {
    const { participant_a0, value } = action.payload;

    return {
        ...state,
        participant_details: {
            ...state.participant_details,
            [participant_a0]: {
                ...(state.participant_details[participant_a0] || {}),
                ...value
            }
        }
    };
};

const setParticipantSessions = (state, action) => {
    const { participant_a0, value } = action.payload

    return {
        ...state,
        participant_sessions: {
            ...state.participant_sessions,
            [participant_a0]: value
        }
    }
}

const setParticipantSessionDetails = (state, action) => {
    const { participant_a0, module_id, value } = action.payload;

    return {
        ...state,
        participant_session_details: {
            ...state.participant_session_details,
            [participant_a0]: {
                ...(state.participant_session_details[participant_a0] || {}),
                [module_id]: value
            }
        }
    };
}

const setAvailableExercises = (state, action) => {
        const { participant_a0, value } = action.payload

    return {
        ...state,
        available_exercises: {
            ...state.available_exercises,
            [participant_a0]: value
        }
    }
}

export default handleActions({
    [actions.changeLocation]: changeLocation,
    [actions.resetParticipants]: resetParticipants,
    [actions.setParticipant]: setParticipant,
    [actions.setActiveParticipants]: setActiveParticipants,
    [actions.setArchivedParticipants]: setArchivedParticipants,
    [actions.setParticipantDetails]: setParticipantDetails,
    [actions.setParticipantSessions]: setParticipantSessions,
    [actions.setParticipantSessionDetails]: setParticipantSessionDetails,
    [actions.setAvailableExercises]: setAvailableExercises
}, defaultState)



// WEBPACK FOOTER //
// ./src/store/reducers/participants.js